export default "__VITE_ASSET__BDLvQDJx__ 400w, __VITE_ASSET__CTW6s0ps__ 800w, __VITE_ASSET__qHo919Zo__ 1024w";